import React from "react";
import CourseStructureRouter from "../courseStructureRouter";

const CourseStructureWrapper = () => {
    return (
        <CourseStructureRouter />
    )
}

export default CourseStructureWrapper;
